/* ============================================================================
   TOPLINE CRICKET — app.js
   Shared behaviours: nav, drawer (enquiry/booking), product grid + filters,
   faux live calendar for Book a Lane, scroll reveal, simple toasts.
   ========================================================================== */

(function () {
  /* ---------- ICONS ---------- */
  const ICONS = {
    search: '<svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="2"><circle cx="11" cy="11" r="7"/><path d="m20 20-3.5-3.5"/></svg>',
    user: '<svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="2"><circle cx="12" cy="8" r="4"/><path d="M4 21c0-4 4-7 8-7s8 3 8 7"/></svg>',
    bag: '<svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="2"><path d="M5 8h14l-1 12H6L5 8Z"/><path d="M9 8a3 3 0 0 1 6 0"/></svg>',
    menu: '<svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="2"><path d="M4 7h16M4 12h16M4 17h16"/></svg>',
    close: '<svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="2"><path d="M6 6l12 12M18 6L6 18"/></svg>',
    arrow: '<svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" stroke-width="2"><path d="M5 12h14M13 6l6 6-6 6"/></svg>',
    arrowL: '<svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" stroke-width="2"><path d="M19 12H5M11 6l-6 6 6 6"/></svg>',
    check: '<svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" stroke-width="2"><path d="m5 12 5 5L20 7"/></svg>',
    clock: '<svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" stroke-width="2"><circle cx="12" cy="12" r="9"/><path d="M12 7v5l3 2"/></svg>',
    pin: '<svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" stroke-width="2"><path d="M12 22s7-7 7-12a7 7 0 0 0-14 0c0 5 7 12 7 12Z"/><circle cx="12" cy="10" r="2.5"/></svg>',
    phone: '<svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" stroke-width="2"><path d="M5 4c0 9 6 15 15 15l1.5-3.2-4.3-2-1.5 1.7c-2.3-1.1-4.1-2.9-5.2-5.2l1.7-1.5-2-4.3L7 5l-2-1Z"/></svg>',
    mail: '<svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" stroke-width="2"><rect x="3" y="5" width="18" height="14" rx="2"/><path d="m3 7 9 6 9-6"/></svg>',
    star: '<svg viewBox="0 0 24 24" width="16" height="16" fill="currentColor"><path d="m12 2 3 6.5 7 .8-5.3 4.8L18 21l-6-3.4L6 21l1.3-7L2 9.3l7-.8L12 2Z"/></svg>',
    bat: '<svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" stroke-width="2"><path d="m4 19 1 1 4-4M5 18l11-11 1.5 1.5L6.5 19.5 5 18Z"/><path d="m17 7 3-3a1 1 0 0 1 1.4 0l.6.6a1 1 0 0 1 0 1.4l-3 3"/></svg>',
    ball: '<svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" stroke-width="2"><circle cx="12" cy="12" r="9"/><path d="M3 12h18M12 3a14 14 0 0 1 0 18M12 3a14 14 0 0 0 0 18"/></svg>',
    lane: '<svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" stroke-width="2"><path d="M4 4h4v16H4zM10 4h4v16h-4zM16 4h4v16h-4z"/></svg>',
    trophy: '<svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" stroke-width="2"><path d="M8 4h8v6a4 4 0 0 1-8 0V4Z"/><path d="M4 6h4M16 6h4M9 16h6M10 20h4M12 14v6"/></svg>',
    pad: '<svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" stroke-width="2"><rect x="6" y="3" width="12" height="18" rx="3"/><path d="M9 7h6M9 11h6M9 15h6"/></svg>',
    glove: '<svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" stroke-width="2"><path d="M7 11V7a2 2 0 0 1 4 0v4M11 11V5a2 2 0 0 1 4 0v6M15 11V7a2 2 0 0 1 4 0v6c0 4-3 7-7 7s-7-3-7-7v-2a2 2 0 1 1 4 0"/></svg>',
    helmet: '<svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" stroke-width="2"><path d="M3 14a9 9 0 0 1 18 0v3H3v-3Z"/><path d="M7 17v3M17 17v3M3 14h18"/></svg>',
    shoe: '<svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" stroke-width="2"><path d="M3 17c0-3 2-4 4-5l3-1 4-4 5 4c2 1 3 3 3 5v2H3v-1Z"/></svg>',
    bagItem: '<svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" stroke-width="2"><rect x="3" y="6" width="18" height="14" rx="2"/><path d="M8 6V4h8v2M3 11h18"/></svg>',
    play: '<svg viewBox="0 0 24 24" width="14" height="14" fill="currentColor"><path d="M8 5v14l11-7L8 5Z"/></svg>',
    inst: '<svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" stroke-width="2"><rect x="3" y="3" width="18" height="18" rx="5"/><circle cx="12" cy="12" r="4"/><circle cx="17.5" cy="6.5" r="1" fill="currentColor"/></svg>',
    fb: '<svg viewBox="0 0 24 24" width="16" height="16" fill="currentColor"><path d="M13 22V12h3l1-4h-4V5.5C13 4.5 13.5 4 15 4h2V0h-3c-3.3 0-5 1.7-5 5v3H6v4h3v10h4Z"/></svg>',
    yt: '<svg viewBox="0 0 24 24" width="16" height="16" fill="currentColor"><path d="M22 7c-.2-1.5-1-2.5-2.4-2.7C17.2 4 12 4 12 4s-5.2 0-7.6.3C3 4.5 2.2 5.5 2 7c-.2 1.6-.2 5-.2 5s0 3.4.2 5c.2 1.5 1 2.5 2.4 2.7C6.8 20 12 20 12 20s5.2 0 7.6-.3c1.4-.2 2.2-1.2 2.4-2.7.2-1.6.2-5 .2-5s0-3.4-.2-5ZM10 15V9l5 3-5 3Z"/></svg>',
    tw: '<svg viewBox="0 0 24 24" width="16" height="16" fill="currentColor"><path d="M18 3h3l-7 8 8 10h-6l-5-6-5 6H2l7-9L1 3h6l4 5 5-5Z"/></svg>',
    chev: '<svg viewBox="0 0 24 24" width="14" height="14" fill="none" stroke="currentColor" stroke-width="2.5"><path d="m9 6 6 6-6 6"/></svg>',
    plus: '<svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" stroke-width="2.5"><path d="M5 12h14M12 5v14"/></svg>',
  };

  function paintIcons() {
    document.querySelectorAll('[data-icon]').forEach(el => {
      const k = el.getAttribute('data-icon');
      if (ICONS[k]) el.innerHTML = ICONS[k];
    });
  }

  /* ---------- MOBILE NAV ---------- */
  function bindNav() {
    const nav = document.querySelector('.primary-nav');
    const tog = document.querySelector('.menu-toggle');
    if (!nav || !tog) return;
    tog.addEventListener('click', () => {
      const open = nav.classList.toggle('open');
      tog.innerHTML = open ? ICONS.close : ICONS.menu;
    });
  }

  /* ---------- SEARCH OVERLAY ---------- */
  // Static page index — gives users a way to jump to sections even without product matches.
  const PAGE_INDEX = [
    { title: 'Home', desc: 'Topline Cricket — overview', url: 'index.html', tags: 'home main landing' },
    { title: 'Shop', desc: 'Bats, gloves, pads, helmets, footwear', url: 'shop.html', tags: 'shop store products bats gloves pads helmets footwear protection accessories' },
    { title: 'Book a Lane', desc: 'Reserve one of our 4 indoor lanes', url: 'book-lane.html', tags: 'book lane net practice booking reserve indoor' },
    { title: 'Hitz Programs', desc: 'Holiday camps, T20 clinics, masterclasses', url: 'hitz.html', tags: 'hitz program camp clinic masterclass training holiday spin pace t20' },
    { title: 'JCL Tournament', desc: 'Junior Cricket League', url: 'jcl.html', tags: 'jcl junior cricket league tournament competition' },
    { title: 'International Tours', desc: 'Sri Lanka, India, England — overseas tours', url: 'tours.html', tags: 'tours india sri lanka england overseas international travel' },
    { title: 'Topline Trophies', desc: 'Trophies, medals, plaques, engraving', url: 'trophies.html', tags: 'trophies medals plaques shields engraving cup awards ribbons glass crystal' },
    { title: 'Coaches', desc: 'Test cricketers & high-performance specialists', url: 'coaches.html', tags: 'coaches coaching staff rangana herath nuwan kulasekara shashikala rhian andy' },
    { title: 'About', desc: 'Our story, since 1995', url: 'about.html', tags: 'about story history bayswater melbourne 1995' },
    { title: 'Members', desc: 'Membership tiers & benefits', url: 'membership.html', tags: 'members membership tier subscription pricing' },
    { title: 'Bat Workshop', desc: 'Knock-in, re-grip, repairs', url: 'shop.html', tags: 'bat workshop knock-in regrip grip repair maintenance batcave' },
  ];

  let _searchProducts = null;
  async function loadSearchProducts() {
    if (_searchProducts !== null) return _searchProducts;
    if (window.TOPLINE_PRODUCTS) { _searchProducts = window.TOPLINE_PRODUCTS; return _searchProducts; }
    try {
      const res = await fetch('assets/data/products.json');
      _searchProducts = await res.json();
    } catch(e) { _searchProducts = []; }
    return _searchProducts;
  }

  function ensureSearchOverlay() {
    if (document.getElementById('search-overlay')) return;
    const o = document.createElement('div');
    o.id = 'search-overlay';
    o.className = 'search-overlay';
    o.innerHTML = `
      <div class="search-backdrop" data-search-close></div>
      <div class="search-modal" role="dialog" aria-label="Site search">
        <div class="search-bar">
          <span class="search-icn">${ICONS.search}</span>
          <input type="search" id="search-input" placeholder="Search products, pages, coaches…" autocomplete="off" />
          <button class="icon-btn search-close" data-search-close aria-label="Close search">${ICONS.close}</button>
        </div>
        <div class="search-results" id="search-results"></div>
        <div class="search-foot">
          <span><kbd>↑</kbd><kbd>↓</kbd> to navigate</span>
          <span><kbd>↵</kbd> to open</span>
          <span><kbd>esc</kbd> to close</span>
        </div>
      </div>
    `;
    document.body.appendChild(o);

    const input = o.querySelector('#search-input');
    const list = o.querySelector('#search-results');

    o.addEventListener('click', e => {
      if (e.target.closest('[data-search-close]')) closeSearch();
    });

    input.addEventListener('input', e => renderSearch(e.target.value));
    input.addEventListener('keydown', e => {
      const items = list.querySelectorAll('[data-result]');
      const cur = list.querySelector('[data-result].active');
      let idx = Array.from(items).indexOf(cur);
      if (e.key === 'ArrowDown') {
        e.preventDefault();
        idx = (idx + 1) % items.length;
        items.forEach(i => i.classList.remove('active'));
        if (items[idx]) { items[idx].classList.add('active'); items[idx].scrollIntoView({ block:'nearest' }); }
      } else if (e.key === 'ArrowUp') {
        e.preventDefault();
        idx = idx <= 0 ? items.length - 1 : idx - 1;
        items.forEach(i => i.classList.remove('active'));
        if (items[idx]) { items[idx].classList.add('active'); items[idx].scrollIntoView({ block:'nearest' }); }
      } else if (e.key === 'Enter') {
        const target = cur || items[0];
        if (target) target.click();
      } else if (e.key === 'Escape') {
        closeSearch();
      }
    });

    document.addEventListener('keydown', e => {
      if (e.key === 'Escape' && o.classList.contains('open')) closeSearch();
    });
  }

  async function renderSearch(q) {
    q = (q || '').trim().toLowerCase();
    const list = document.getElementById('search-results');
    if (!list) return;

    if (!q) {
      // Show suggested pages when empty
      const suggested = PAGE_INDEX.slice(0, 6);
      list.innerHTML = `
        <div class="search-section">
          <span class="search-label">Quick links</span>
          ${suggested.map(p => `
            <a class="search-result" data-result href="${p.url}">
              <span class="sr-icn">${ICONS.arrow}</span>
              <span class="sr-body">
                <strong>${p.title}</strong>
                <span>${p.desc}</span>
              </span>
              <span class="sr-meta">Page</span>
            </a>
          `).join('')}
        </div>
      `;
      const first = list.querySelector('[data-result]'); if (first) first.classList.add('active');
      return;
    }

    // Match pages
    const pageHits = PAGE_INDEX.filter(p =>
      (p.title + ' ' + p.desc + ' ' + p.tags).toLowerCase().includes(q)
    ).slice(0, 6);

    // Match products
    const products = await loadSearchProducts();
    const productHits = products.filter(p => {
      const hay = (p.name + ' ' + p.brand + ' ' + p.category).toLowerCase();
      return hay.includes(q);
    }).slice(0, 8);

    let html = '';
    if (pageHits.length) {
      html += `<div class="search-section">
        <span class="search-label">Pages</span>
        ${pageHits.map(p => `
          <a class="search-result" data-result href="${p.url}">
            <span class="sr-icn">${ICONS.arrow}</span>
            <span class="sr-body">
              <strong>${highlight(p.title, q)}</strong>
              <span>${highlight(p.desc, q)}</span>
            </span>
            <span class="sr-meta">Page</span>
          </a>
        `).join('')}
      </div>`;
    }
    if (productHits.length) {
      html += `<div class="search-section">
        <span class="search-label">Products (${productHits.length} of ${products.filter(p=>(p.name+' '+p.brand+' '+p.category).toLowerCase().includes(q)).length})</span>
        ${productHits.map(p => `
          <a class="search-result" data-result href="shop.html?cat=${encodeURIComponent(p.category)}">
            <span class="sr-icn">${ICONS.bagItem}</span>
            <span class="sr-body">
              <strong>${highlight(p.name, q)}</strong>
              <span>${p.brand} · ${p.category}${p.price ? ' · $' + p.price : ''}</span>
            </span>
            <span class="sr-meta">Shop</span>
          </a>
        `).join('')}
      </div>`;
    }
    if (!html) {
      html = `<div class="search-empty">
        <strong>Nothing matched "${escapeHtml(q)}"</strong>
        <p>Try a brand (Kookaburra, MRF), category (Bats, Gloves), or page name.</p>
      </div>`;
    }
    list.innerHTML = html;
    const first = list.querySelector('[data-result]'); if (first) first.classList.add('active');
  }

  function highlight(text, q) {
    if (!q) return escapeHtml(text);
    const safe = escapeHtml(text);
    const re = new RegExp('(' + q.replace(/[.*+?^${}()|[\]\\]/g, '\\$&') + ')', 'ig');
    return safe.replace(re, '<mark>$1</mark>');
  }
  function escapeHtml(s) {
    return String(s).replace(/[&<>"']/g, c => ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c]));
  }

  function openSearch() {
    ensureSearchOverlay();
    const o = document.getElementById('search-overlay');
    o.classList.add('open');
    document.body.style.overflow = 'hidden';
    renderSearch('');
    setTimeout(() => {
      const i = document.getElementById('search-input');
      if (i) i.focus();
    }, 50);
  }
  function closeSearch() {
    const o = document.getElementById('search-overlay');
    if (!o) return;
    o.classList.remove('open');
    document.body.style.overflow = '';
  }

  function bindSearch() {
    document.querySelectorAll('[data-icon="search"]').forEach(b => {
      b.addEventListener('click', openSearch);
    });
    // keyboard shortcut: Cmd/Ctrl+K
    document.addEventListener('keydown', e => {
      if ((e.metaKey || e.ctrlKey) && e.key.toLowerCase() === 'k') {
        e.preventDefault();
        const o = document.getElementById('search-overlay');
        if (o && o.classList.contains('open')) closeSearch(); else openSearch();
      }
    });
  }

  /* ---------- TOAST ---------- */
  let toastTimer;
  function toast(msg) {
    let el = document.querySelector('.toast');
    if (!el) { el = document.createElement('div'); el.className = 'toast'; document.body.appendChild(el); }
    el.textContent = msg;
    el.classList.add('show');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(() => el.classList.remove('show'), 2400);
  }

  /* ---------- ENQUIRY DRAWER ---------- */
  // Stores selected items (products to enquire about) AND/OR a booking selection.
  const STATE = {
    enquiries: JSON.parse(localStorage.getItem('tc_enq') || '[]'),
    booking: JSON.parse(localStorage.getItem('tc_book') || 'null'),
  };
  function persist() {
    localStorage.setItem('tc_enq', JSON.stringify(STATE.enquiries));
    localStorage.setItem('tc_book', JSON.stringify(STATE.booking));
    paintCount();
  }
  function paintCount() {
    const n = STATE.enquiries.length + (STATE.booking ? 1 : 0);
    document.querySelectorAll('[data-cart-count]').forEach(el => {
      el.textContent = n;
      el.style.display = n ? 'inline-flex' : 'none';
    });
  }
  function ensureDrawer() {
    if (document.getElementById('enq-drawer')) return;
    const d = document.createElement('div');
    d.id = 'enq-drawer'; d.className = 'drawer';
    d.innerHTML = `
      <div class="drawer-header">
        <h3>Your Enquiry</h3>
        <button class="icon-btn" data-close>${ICONS.close}</button>
      </div>
      <div class="drawer-body" id="enq-body"></div>
      <div class="drawer-footer" id="enq-footer"></div>
    `;
    const o = document.createElement('div');
    o.className = 'drawer-overlay'; o.id = 'enq-overlay';
    document.body.appendChild(o); document.body.appendChild(d);
    o.addEventListener('click', closeDrawer);
    d.querySelector('[data-close]').addEventListener('click', closeDrawer);
  }
  function openDrawer() {
    ensureDrawer();
    document.getElementById('enq-drawer').classList.add('open');
    document.getElementById('enq-overlay').classList.add('show');
    renderDrawer();
  }
  function closeDrawer() {
    const d = document.getElementById('enq-drawer');
    const o = document.getElementById('enq-overlay');
    if (d) d.classList.remove('open');
    if (o) o.classList.remove('show');
  }
  function renderDrawer() {
    const body = document.getElementById('enq-body');
    const foot = document.getElementById('enq-footer');
    if (!body || !foot) return;

    let html = '';
    if (STATE.booking) {
      const b = STATE.booking;
      html += `
        <h4 style="font-family:var(--font-body);font-size:12px;letter-spacing:.18em;color:var(--lime);text-transform:uppercase;margin:0 0 10px;font-weight:700">Lane booking</h4>
        <div class="enquiry-item" style="grid-template-columns:1fr">
          <div>
            <h5>${b.lane} — ${b.type}</h5>
            <p class="meta">${b.dateLabel} · ${b.time} · ${b.duration}min · $${b.price}</p>
          </div>
          <button data-clear-book style="text-align:right;padding:0;margin-top:8px;font-size:12px;letter-spacing:.12em;text-transform:uppercase;font-weight:700">Remove</button>
        </div>
        <div class="divider" style="margin:20px 0"></div>
      `;
    }

    if (STATE.enquiries.length) {
      html += `<h4 style="font-family:var(--font-body);font-size:12px;letter-spacing:.18em;color:var(--lime);text-transform:uppercase;margin:0 0 10px;font-weight:700">Products (${STATE.enquiries.length})</h4>`;
      html += `<div class="enquiry-list">`;
      STATE.enquiries.forEach(p => {
        html += `
          <div class="enquiry-item">
            <div>
              <h5>${p.name}</h5>
              <span class="meta">${p.brand} · ${p.category}${p.price ? ' · $'+p.price : ''}</span>
            </div>
            <button data-remove="${p.id}">${ICONS.close}</button>
          </div>`;
      });
      html += `</div>`;
    }

    if (!STATE.booking && !STATE.enquiries.length) {
      html = `<div class="empty-state"><p>Nothing in your enquiry yet.</p><p style="margin-top:8px;font-size:13px">Add products from the Shop or book a lane to start.</p></div>`;
      foot.innerHTML = '';
      body.innerHTML = html;
      return;
    }

    body.innerHTML = html;

    foot.innerHTML = `
      <form id="enq-form" class="form" style="display:grid;gap:10px">
        <input required type="text" name="name" placeholder="Your name" />
        <input required type="email" name="email" placeholder="Email address" />
        <input type="tel" name="phone" placeholder="Phone" />
        <textarea name="msg" placeholder="Anything we should know?" style="min-height:80px"></textarea>
        <button class="btn btn-primary" style="justify-content:center" type="submit">Send Enquiry ${ICONS.arrow}</button>
        <p style="font-size:11px;color:var(--t-on-dark-mute);text-align:center">We reply within one business day.</p>
      </form>
    `;

    foot.querySelectorAll('input,textarea').forEach(i => {
      i.style.padding='14px 16px'; i.style.background='var(--ink-3)'; i.style.border='1px solid var(--line-strong)';
      i.style.borderRadius='12px'; i.style.color='var(--t-on-dark)'; i.style.fontSize='14px';
    });

    foot.querySelector('#enq-form').addEventListener('submit', e => {
      e.preventDefault();
      toast('Enquiry sent — we’ll be in touch shortly.');
      STATE.enquiries = []; STATE.booking = null; persist(); renderDrawer();
      setTimeout(closeDrawer, 1100);
    });

    body.querySelectorAll('[data-remove]').forEach(b => b.addEventListener('click', () => {
      const id = b.getAttribute('data-remove');
      STATE.enquiries = STATE.enquiries.filter(x => x.id !== id);
      persist(); renderDrawer();
    }));
    const cb = body.querySelector('[data-clear-book]');
    if (cb) cb.addEventListener('click', () => { STATE.booking = null; persist(); renderDrawer(); });
  }

  function addEnquiry(p) {
    if (STATE.enquiries.find(x => x.id === p.id)) {
      toast('Already in your enquiry');
      return;
    }
    STATE.enquiries.push(p); persist();
    toast('Added to enquiry');
  }
  function setBooking(b) {
    STATE.booking = b; persist();
    toast('Lane added — review your booking');
  }

  function bindCartToggles() {
    document.querySelectorAll('[data-cart-toggle]').forEach(b => b.addEventListener('click', openDrawer));
  }

  /* ---------- SCROLL REVEAL ---------- */
  function bindReveal() {
    const els = document.querySelectorAll('.reveal');
    const grids = document.querySelectorAll('.feature-grid, .coach-grid, .tour-grid, .tier-grid');
    if (!('IntersectionObserver' in window)) {
      els.forEach(e => e.classList.add('in'));
      grids.forEach(g => g.classList.add('in-grid'));
      return;
    }
    const io = new IntersectionObserver((entries) => {
      entries.forEach(en => { if (en.isIntersecting) { en.target.classList.add('in'); io.unobserve(en.target); }});
    }, { threshold: .12 });
    els.forEach(e => io.observe(e));

    // Grids — stagger via .in-grid
    const gridIO = new IntersectionObserver((entries) => {
      entries.forEach(en => { if (en.isIntersecting) { en.target.classList.add('in-grid'); gridIO.unobserve(en.target); }});
    }, { threshold: .15 });
    grids.forEach(g => gridIO.observe(g));
  }

  /* ---------- SCROLL PROGRESS BAR ---------- */
  function bindScrollProgress() {
    const bar = document.createElement('div');
    bar.className = 'scroll-progress';
    document.body.appendChild(bar);
    const update = () => {
      const h = document.documentElement;
      const p = h.scrollTop / Math.max(1, (h.scrollHeight - h.clientHeight));
      bar.style.transform = `scaleX(${Math.max(0, Math.min(1, p))})`;
    };
    window.addEventListener('scroll', update, { passive: true });
    update();
  }

  /* ---------- HERO SPLIT-TEXT ---------- */
  function splitHeroText() {
    document.querySelectorAll('.hero h1 .gline').forEach(line => {
      // Wrap entire line content in a span so we can translate it as one unit
      // (avoids per-letter wrapping which can break italic kerning + word breaks)
      if (line.querySelector('span')) return;
      const inner = line.innerHTML;
      line.innerHTML = `<span>${inner}</span>`;
    });
  }

  /* ---------- ANIMATED COUNTERS ---------- */
  function bindCounters() {
    const counters = document.querySelectorAll('[data-count]');
    if (!counters.length || !('IntersectionObserver' in window)) {
      counters.forEach(c => c.textContent = c.getAttribute('data-count'));
      return;
    }
    const ease = t => 1 - Math.pow(1 - t, 3);
    const animate = (el) => {
      const target = +el.getAttribute('data-count') || 0;
      const suffix = el.getAttribute('data-suffix') || '';
      const prefix = el.getAttribute('data-prefix') || '';
      const decimals = +el.getAttribute('data-decimals') || 0;
      const dur = 1500;
      const t0 = performance.now();
      const tick = (now) => {
        const t = Math.min(1, (now - t0) / dur);
        const v = target * ease(t);
        el.textContent = prefix + v.toFixed(decimals) + suffix;
        if (t < 1) requestAnimationFrame(tick);
      };
      requestAnimationFrame(tick);
    };
    const io = new IntersectionObserver((entries) => {
      entries.forEach(en => { if (en.isIntersecting) { animate(en.target); io.unobserve(en.target); }});
    }, { threshold: .4 });
    counters.forEach(c => { c.textContent = (c.getAttribute('data-prefix')||'') + '0' + (c.getAttribute('data-suffix')||''); io.observe(c); });
  }

  /* ---------- MAGNETIC BUTTONS ---------- */
  function bindMagnetic() {
    if (window.matchMedia('(pointer: coarse)').matches) return;
    document.querySelectorAll('.btn-primary, .btn-ghost').forEach(btn => {
      btn.addEventListener('mousemove', e => {
        const r = btn.getBoundingClientRect();
        const x = e.clientX - r.left - r.width/2;
        const y = e.clientY - r.top - r.height/2;
        btn.style.transform = `translate(${x*.15}px, ${y*.25}px)`;
      });
      btn.addEventListener('mouseleave', () => { btn.style.transform = ''; });
    });
  }

  /* ---------- CURSOR DOT ---------- */
  function bindCursor() {
    return; // disabled — using native cursor
    if (window.matchMedia('(pointer: coarse)').matches) return;
    const dot = document.createElement('div');
    dot.className = 'cursor-dot';
    document.body.appendChild(dot);
    let x = 0, y = 0, tx = 0, ty = 0;
    document.addEventListener('mousemove', e => { tx = e.clientX; ty = e.clientY; });
    const loop = () => {
      x += (tx - x) * .25; y += (ty - y) * .25;
      dot.style.transform = `translate(${x}px, ${y}px) translate(-50%, -50%)`;
      requestAnimationFrame(loop);
    };
    requestAnimationFrame(loop);
    // hover state on interactive elements
    document.addEventListener('mouseover', e => {
      if (e.target.closest('a, button, .product-card, .coach-card, .tour-card, .feature-card, .cat-card, .slot:not(.taken)')) {
        dot.classList.add('hover');
      }
    });
    document.addEventListener('mouseout', e => {
      if (e.target.closest('a, button, .product-card, .coach-card, .tour-card, .feature-card, .cat-card, .slot:not(.taken)')) {
        dot.classList.remove('hover');
      }
    });
  }

  /* ---------- PRODUCT GRID + FILTERS (Shop page) ---------- */
  function categoryIcon(cat) {
    return ({
      'Bats': ICONS.bat, 'Balls': ICONS.ball, 'Pads': ICONS.pad,
      'Gloves': ICONS.glove, 'Helmets': ICONS.helmet, 'Footwear': ICONS.shoe,
      'Bags': ICONS.bagItem, 'Protection': ICONS.pad, 'Apparel': ICONS.bagItem,
      'Accessories': ICONS.trophy
    })[cat] || ICONS.bat;
  }
  function stockTag(qty) {
    if (qty <= 0) return '<span class="stock-tag out">Order in</span>';
    if (qty <= 3) return '<span class="stock-tag low">Low stock</span>';
    return '<span class="stock-tag">In stock</span>';
  }

  async function initShop() {
    const grid = document.getElementById('productGrid');
    if (!grid) return;
    let products = [];
    if (window.TOPLINE_PRODUCTS) {
      products = window.TOPLINE_PRODUCTS;
    } else {
      try {
        const res = await fetch('assets/data/products.json');
        products = await res.json();
      } catch(e) { console.error('Could not load products', e); return; }
    }

    const state = {
      cats: new Set(), brands: new Set(), handed: 'any',
      min: 0, max: 9999, q: '', sort: 'popular'
    };

    // Build dynamic brand filter from data
    const brandList = [...new Set(products.map(p=>p.brand))].sort();
    const brandBox = document.querySelector('[data-brand-list]');
    if (brandBox) {
      brandBox.innerHTML = brandList.map(b => `<label><input type="checkbox" data-filter="brand" value="${b}"/> ${b}</label>`).join('');
    }
    const catBox = document.querySelector('[data-cat-list]');
    if (catBox) {
      const cats = [...new Set(products.map(p=>p.category))].sort();
      catBox.innerHTML = cats.map(c => `<label><input type="checkbox" data-filter="category" value="${c}"/> ${c}</label>`).join('');
    }

    function applyFilters() {
      let r = products.slice();
      if (state.cats.size) r = r.filter(p => state.cats.has(p.category));
      if (state.brands.size) r = r.filter(p => state.brands.has(p.brand));
      if (state.handed !== 'any') r = r.filter(p => p.handed === 'Either' || p.handed === state.handed);
      if (state.min) r = r.filter(p => (p.price||0) >= state.min);
      if (state.max && state.max < 9999) r = r.filter(p => (p.price||0) <= state.max);
      if (state.q) {
        const q = state.q.toLowerCase();
        r = r.filter(p => p.name.toLowerCase().includes(q) || p.brand.toLowerCase().includes(q));
      }
      if (state.sort === 'price-asc') r.sort((a,b)=>(a.price||9999)-(b.price||9999));
      else if (state.sort === 'price-desc') r.sort((a,b)=>(b.price||0)-(a.price||0));
      else if (state.sort === 'name') r.sort((a,b)=>a.name.localeCompare(b.name));
      else r.sort((a,b)=>(b.qty||0)-(a.qty||0)); // popular = highest stock first

      const cnt = document.getElementById('shopCount');
      if (cnt) cnt.textContent = `${r.length} of ${products.length} products`;

      if (!r.length) {
        grid.innerHTML = `<div class="empty-state" style="grid-column:1/-1"><h3 style="margin-bottom:8px">No matches</h3><p>Try clearing a filter or call us on (03) 9876 5432.</p></div>`;
        return;
      }
      grid.innerHTML = r.slice(0, 80).map(p => `
        <article class="product-card">
          <div class="product-thumb">
            ${categoryIcon(p.category)}
          </div>
          <div class="product-info">
            <h4>${p.name}</h4>
            ${p.price ? `<span class="price">$${p.price} AUD</span>` : `<span class="price poa">P.O.A.</span>`}
            <button class="enquire" data-enq='${JSON.stringify({id:p.id, name:p.name, brand:p.brand, category:p.category, price:p.price}).replace(/'/g,"&#39;")}'>Shop Now ${ICONS.arrow}</button>
          </div>
        </article>
      `).join('');

      grid.querySelectorAll('[data-enq]').forEach(b => b.addEventListener('click', e => {
        const p = JSON.parse(b.getAttribute('data-enq').replace(/&#39;/g, "'"));
        addEnquiry(p);
      }));
    }

    // bind controls
    document.body.addEventListener('change', e => {
      const t = e.target;
      if (t.matches('[data-filter="category"]')) {
        if (t.checked) state.cats.add(t.value); else state.cats.delete(t.value);
        applyFilters();
      } else if (t.matches('[data-filter="brand"]')) {
        if (t.checked) state.brands.add(t.value); else state.brands.delete(t.value);
        applyFilters();
      } else if (t.matches('[name="handed"]')) {
        state.handed = t.value; applyFilters();
      } else if (t.id === 'sortBy') {
        state.sort = t.value; applyFilters();
      }
    });
    document.body.addEventListener('input', e => {
      const t = e.target;
      if (t.id === 'searchBox') { state.q = t.value; applyFilters(); }
      if (t.id === 'minPrice') { state.min = +t.value || 0; applyFilters(); }
      if (t.id === 'maxPrice') { state.max = +t.value || 9999; applyFilters(); }
    });

    const clear = document.getElementById('clearFilters');
    if (clear) clear.addEventListener('click', () => {
      document.querySelectorAll('input[type="checkbox"][data-filter]').forEach(i => i.checked=false);
      const sb = document.getElementById('searchBox'); if (sb) sb.value='';
      const min = document.getElementById('minPrice'); if (min) min.value='';
      const max = document.getElementById('maxPrice'); if (max) max.value='';
      const ha = document.querySelector('input[name="handed"][value="any"]'); if (ha) ha.checked=true;
      state.cats.clear(); state.brands.clear(); state.handed='any'; state.min=0; state.max=9999; state.q='';
      applyFilters();
    });

    // Cat-from-URL (?cat=Bats)
    const params = new URLSearchParams(location.search);
    if (params.get('cat')) {
      const c = params.get('cat');
      const cb = document.querySelector(`[data-filter="category"][value="${c}"]`);
      if (cb) { cb.checked = true; state.cats.add(c); }
    }

    applyFilters();
  }

  /* ---------- BOOK A LANE — faux live calendar ---------- */
  // Deterministic pseudo-random per (date, lane, slot) so the same user sees same availability.
  function hash(s) { let h=2166136261; for (let i=0;i<s.length;i++){ h^=s.charCodeAt(i); h=Math.imul(h,16777619);} return (h>>>0); }
  function rng(seed) { return (hash(seed) % 1000) / 1000; }

  const LANES = [
    { id: 1, label: 'Lane 1', type: 'Turf · 10s replay', price: 45 },
    { id: 2, label: 'Lane 2', type: 'Turf · long run-up', price: 45 },
    { id: 3, label: 'Lane 3', type: 'Synthetic · cameras', price: 38 },
    { id: 4, label: 'Lane 4', type: 'Bowling Machine', price: 42 },
  ];
  const SLOTS = ['09:00','10:00','11:00','12:00','13:00','14:00','15:00','16:00','17:00','18:00','19:00','20:00','21:00'];
  const DAY_NAMES = ['SUN','MON','TUE','WED','THU','FRI','SAT'];
  const MO_NAMES = ['JAN','FEB','MAR','APR','MAY','JUN','JUL','AUG','SEP','OCT','NOV','DEC'];

  function fmtDate(d) {
    return `${DAY_NAMES[d.getDay()]} ${d.getDate()} ${MO_NAMES[d.getMonth()]}`;
  }
  function isoDate(d) { return d.toISOString().slice(0,10); }

  function initBooking() {
    const root = document.getElementById('bookCalendar');
    if (!root) return;

    const today = new Date(); today.setHours(0,0,0,0);
    const startOffset = { v: 0 }; // shift week
    const sel = { dateIdx: 0, slot: null, lane: null, duration: 60 };

    function days() {
      const arr = [];
      for (let i=0;i<7;i++) {
        const d = new Date(today); d.setDate(today.getDate() + startOffset.v + i);
        arr.push(d);
      }
      return arr;
    }
    function isTaken(date, lane, slot) {
      const d = isoDate(date);
      // bias: peak hours busier
      const r = rng(`${d}|${lane}|${slot}`);
      const hour = +slot.split(':')[0];
      const peak = (hour >= 17 && hour <= 20) || (date.getDay() % 6 === 0 && hour >= 9 && hour <= 12);
      const threshold = peak ? .7 : .35;
      // Past slots taken
      const now = new Date();
      const ts = new Date(date); ts.setHours(hour,0,0,0);
      if (ts < now) return true;
      return r < threshold;
    }

    function render() {
      const ds = days();
      // header strip
      const stripHTML = ds.map((d,i) => `
        <button data-day="${i}" class="${i===sel.dateIdx ? 'active' : ''}">
          <span class="dow">${DAY_NAMES[d.getDay()]}</span>
          <span class="dnum">${d.getDate()}</span>
          <span class="dmo">${MO_NAMES[d.getMonth()]}</span>
        </button>
      `).join('');

      const date = ds[sel.dateIdx];

      // lane rows
      const rows = LANES.map(L => `
        <div class="row">
          <div class="lane-lbl">${L.label}<span class="type">${L.type}</span></div>
          <div class="slots">
            ${SLOTS.map(s => {
              const taken = isTaken(date, L.id, s);
              const selected = sel.lane === L.id && sel.slot === s && sel.dateIso === isoDate(date);
              const cls = taken ? 'slot taken' : (selected ? 'slot selected' : 'slot');
              return `<button class="${cls}" data-slot="${s}" data-lane="${L.id}" ${taken ? 'disabled' : ''}>${s}</button>`;
            }).join('')}
          </div>
        </div>
      `).join('');

      root.innerHTML = `
        <div class="calendar-head">
          <div>
            <span class="kicker" style="margin-bottom:6px">Live availability</span>
            <h3>${fmtDate(date)} · ${date.getFullYear()}</h3>
          </div>
          <div class="cal-nav">
            <button data-shift="-7" aria-label="Previous week">${ICONS.arrowL}</button>
            <button data-shift="0" aria-label="This week">Today</button>
            <button data-shift="7" aria-label="Next week">${ICONS.arrow}</button>
          </div>
        </div>
        <div class="day-strip">${stripHTML}</div>
        <div class="lane-table">${rows}</div>
      `;

      root.querySelectorAll('[data-day]').forEach(b => b.addEventListener('click', () => {
        sel.dateIdx = +b.getAttribute('data-day'); render(); paintSummary();
      }));
      root.querySelectorAll('[data-shift]').forEach(b => b.addEventListener('click', () => {
        const v = +b.getAttribute('data-shift');
        if (v === 0) { startOffset.v = 0; sel.dateIdx = 0; }
        else { startOffset.v += v; }
        render(); paintSummary();
      }));
      root.querySelectorAll('.slot:not(.taken)').forEach(s => s.addEventListener('click', () => {
        sel.slot = s.getAttribute('data-slot');
        sel.lane = +s.getAttribute('data-lane');
        sel.dateIso = isoDate(ds[sel.dateIdx]);
        render(); paintSummary();
      }));
    }

    function paintSummary() {
      const sum = document.getElementById('bookSummary');
      if (!sum) return;
      const ds = days();
      const date = ds[sel.dateIdx];
      const lane = LANES.find(l => l.id === sel.lane);
      const totalMul = sel.duration / 60;
      const total = lane ? Math.round(lane.price * totalMul) : 0;

      sum.innerHTML = `
        <span class="kicker">Booking summary</span>
        <h3>Your session</h3>
        <div class="row"><span class="lbl">Date</span><span class="val">${fmtDate(date)}</span></div>
        <div class="row"><span class="lbl">Time</span><span class="val">${sel.slot || '—'}</span></div>
        <div class="row"><span class="lbl">Lane</span><span class="val">${lane ? lane.label + ' · ' + lane.type : '—'}</span></div>
        <div class="row">
          <span class="lbl">Duration</span>
          <select id="durSel">
            <option value="60" ${sel.duration===60?'selected':''}>60 min</option>
            <option value="90" ${sel.duration===90?'selected':''}>90 min</option>
            <option value="120" ${sel.duration===120?'selected':''}>120 min</option>
          </select>
        </div>
        <div class="row" style="border-top:1px solid var(--line-strong);padding-top:18px">
          <span class="lbl">Total</span>
          <span class="total">${total ? '$'+total : '—'}</span>
        </div>
        <div class="legend"><span><i class="av"></i>Available</span><span><i class="tk"></i>Taken</span><span><i class="sl"></i>Selected</span></div>
        <div class="form" style="margin-top:18px;display:grid;gap:10px">
          <input id="bkName" placeholder="Your name" />
          <input id="bkEmail" placeholder="Email" type="email" />
          <input id="bkPhone" placeholder="Phone" type="tel" />
          <button id="bkConfirm" class="btn btn-primary" style="justify-content:center" ${!sel.slot ? 'disabled style="opacity:.4;cursor:not-allowed"' : ''}>Confirm Booking ${ICONS.arrow}</button>
        </div>
      `;
      const ds2 = sum.querySelector('#durSel');
      if (ds2) ds2.addEventListener('change', () => { sel.duration = +ds2.value; paintSummary(); });
      const cf = sum.querySelector('#bkConfirm');
      if (cf) cf.addEventListener('click', () => {
        if (!sel.slot || !lane) return;
        const name = (sum.querySelector('#bkName')||{}).value || 'Guest';
        const email = (sum.querySelector('#bkEmail')||{}).value || '';
        if (!email) { toast('Email required'); return; }
        setBooking({
          dateLabel: fmtDate(date),
          dateIso: isoDate(date),
          time: sel.slot,
          lane: lane.label,
          type: lane.type,
          duration: sel.duration,
          price: total,
          name, email,
        });
        setTimeout(openDrawer, 200);
      });
    }

    render(); paintSummary();
  }

  /* ---------- HOME hero parallax ---------- */
  function bindHeroParallax() {
    const ball = document.querySelector('.hero-ball');
    if (!ball) return;
    window.addEventListener('scroll', () => {
      const y = window.scrollY;
      ball.style.transform = `translateY(${y * .15}px) rotate(${y*.05}deg)`;
    }, { passive: true });
  }

  /* ---------- FAQ accordions ---------- */
  function bindFAQ() {
    document.querySelectorAll('[data-faq]').forEach(item => {
      const q = item.querySelector('[data-faq-q]');
      const a = item.querySelector('[data-faq-a]');
      if (!q || !a) return;
      a.style.maxHeight = '0px';
      q.addEventListener('click', () => {
        const isOpen = item.classList.toggle('open');
        a.style.maxHeight = isOpen ? a.scrollHeight + 'px' : '0px';
      });
    });
  }

  /* ---------- BOOT ---------- */
  document.addEventListener('DOMContentLoaded', () => {
    paintIcons();
    bindNav();
    bindSearch();
    bindCartToggles();
    splitHeroText();
    bindReveal();
    bindScrollProgress();
    bindCounters();
    bindMagnetic();
    bindCursor();
    bindHeroParallax();
    bindFAQ();
    initShop();
    initBooking();
    paintCount();
  });
})();
